import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CsrfService } from './csrf.service';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export interface SelfProfile {
  id: number;
  username: string;
  email: string | null;
  displayName: string | null;
  isAdmin: boolean;
  accountStatus: string;
  lastLoginDatetime: string | null;
}

@Injectable({ providedIn: 'root' })
export class SelfService {
  private readonly http = inject(HttpClient);
  private readonly csrf = inject(CsrfService);
  private readonly auth = inject(AuthService);
  private readonly baseUrl = `${environment.apiUrl}/api/v1/tenant/me`;

  private getHeaders() {
    const headers: Record<string, string> = {};
    const token = this.csrf.getToken();
    if (token) headers['x-csrf-token'] = token;
    return headers;
  }

  getProfile(): Observable<SelfProfile> {
    return this.http.get<SelfProfile>(this.baseUrl, { withCredentials: true })
      .pipe(this.auth.catchUnauthorized());
  }

  updateProfile(body: { displayName?: string | null; email?: string | null }): Observable<SelfProfile> {
    return this.http.patch<SelfProfile>(this.baseUrl, body, {
      withCredentials: true,
      headers: this.getHeaders(),
    }).pipe(this.auth.catchUnauthorized());
  }

  changePassword(currentPassword: string, newPassword: string): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.baseUrl}/change-password`,
      { currentPassword, newPassword },
      { withCredentials: true, headers: this.getHeaders() },
    ).pipe(this.auth.catchUnauthorized());
  }
}
